
export const addCameraEntryForMediaStream = async (cameraInfoArr, mediaStreamTrack) => {

    let deviceId = mediaStreamTrack.getSettings().deviceId;

    let screenCap = await mediaStreamTrackToScreenCap(mediaStreamTrack);

    cameraInfoArr.push( {
        deviceId: deviceId,
        label: mediaStreamTrack.label,
        image: screenCap
    })

}

export const haveEntryForDeviceId = (camerInfoArr, deviceId) => {

    for ( let i = 0; i < camerInfoArr.length; i++) {

        if (camerInfoArr[i].deviceId === deviceId) {
            return true
        }

    }

    return false;
}


export const getMediaStreamAndDevices = async (video_width, video_height ) => {

    let cameraAccessFailed = false;

    let mediaPromise = navigator.mediaDevices.getUserMedia({
        audio: false,
        video: {
            width: video_width,
            height: video_height
        }
    }).catch( error => { cameraAccessFailed = true; });

    // Now get the list of devices
    let devicePromise = navigator.mediaDevices.enumerateDevices().catch( () => { cameraAccessFailed = true; } );

    let values = await Promise.all([mediaPromise, devicePromise]);

    return { mediaStream: values[0], mediaDevices: values[1], cameraAccessFailed: cameraAccessFailed };
};


const mediaStreamTrackToScreenCap = async (mediaStreamTrack) => {
    let imageCapture = new ImageCapture(mediaStreamTrack);

    const blobPromise = imageCapture.takePhoto();
    let photoValues = await Promise.all([blobPromise]);
    let converterPromise = blobToBase64(photoValues[0]);
    return await Promise.all([converterPromise]);
}

const blobToBase64 = (blob) => {

    return new Promise((resolve, _) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(blob);
    });

}